import createPermission from 'permissions/createPermission'

export default createPermission('unit.plink.reboot')